import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bbbe8dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))


import store from '../../store'
import type Node from 'element-plus/es/components/tree/src/model/node'
import { defineComponent, ref, onMounted, defineProps, ComponentInternalInstance, getCurrentInstance } from 'vue'
import { apiFetchData, MenuTree, apiPostData, findTreeNode, fillNullId, deepCopy, isEmptyString, isEmptyArray, BaseTree, stringEqual, showRequestResult } from '../../utils'
import { apiToolComponentPath, apiSavePagePath, apiGetPageJsonPath, emptyPage } from '../../config'
import ComponentList from './ComponentList.vue'
import PageEditor from '../../components/PageEditor.vue'
import ViewRender from '../../components/ViewRender.vue'
import TableItemEventEditor from '../../components/TableItemEventEditor.vue'

// 解决vs中的语法错误提示
const __default__ = defineComponent({
  name: 'EditMenuPage'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  item: {
    type: Object,
    required: true
  },
  tabName: {
    type: String,
    required: true
  }
},
  setup(__props) {

// 预览
const refIsPreview = ref(false)
// 是否显示属性窗口
const refIsShow = ref(true)

// 菜单树的span
const refTreeMenuSpan = ref(4)
// 组件工具栏的span
const refComponetToolSpan = ref(4)
// 页面编辑创库的span
const refEditWindowSpan = ref(12)
// 属性窗口的span
const refAtrrWindowSpan = ref(4)

// 组件
const refTools = ref([])

// 选中的菜单的全路径
const refSelectFullPath = ref('')

// 重新计算各区域的span
const recaculateSpan = () => {
  console.log('recaculateSpan refIsShow=', refIsShow.value)
  if (refIsShow.value) {
    refTreeMenuSpan.value = 4
    refComponetToolSpan.value = 4
    refAtrrWindowSpan.value = 4
  } else {
    refTreeMenuSpan.value = 0
    refComponetToolSpan.value = 0
    refAtrrWindowSpan.value = 0
  }
  refEditWindowSpan.value = 24 - refTreeMenuSpan.value - refComponetToolSpan.value - refAtrrWindowSpan.value
}

const onPreview = () => {
  console.log('onPreview store.state.pageItems=', store.state.pageItems)
}

// 保存到服务器
const savePage = () => {
  const path = refPageUrl.value.replace('__get_page', apiSavePagePath)
  apiPostData(path, store.state.pageItems)
    .then(data => {
      console.log('savePage data=', data)
      showRequestResult(data, '保存', '保存', '保存结果')
    })
}
// 菜单绑定的页面返回的页面数据，在这里是菜单树
const props = __props

// 当前菜单关联的页面的url
const refPageUrl = ref('')

// 点击菜单树节点
// 参考 DragTreePage.vue 的分析过程
const onNodeClick = (data: MenuTree, node: Node, nodeInstance: ComponentInternalInstance, e: MouseEvent) => {
  const result = findTreeNode(treeData.value, data.id, '', 0)
  if (result === null || result.depath < 2 ||
    (!isEmptyArray(result.node.children))) {
    // 没找到， 层级小于2（顶层菜单是0）， 有子菜单都不能挂在页面
    return
  }
  refSelectFullPath.value = result.fullPath
  let url = data.url
  if (isEmptyString(url)) {
    url = `${apiGetPageJsonPath}${data.id}.json`
  }
  refPageUrl.value = url
  apiFetchData(url)
    .then(data => {
      if (data === null) {
        data = deepCopy(emptyPage)
      }
      // store.state.curItemId = fillNullId(data)
      fillNullId(data)
      store.state.pageItems = data
      if (isEmptyArray(data.children)) {
        store.state.selectItemInDraggable = {}
      } else {
        store.state.selectItemInDraggable = data.children[0]
      }
    })
}

// 菜单树的数据，
const treeData = ref([] as MenuTree[])

// 重新组织菜单树
function structMenu () {
  const mainMenus = [] as MenuTree[]
  for (let i = 0; i < props.item.data.length; i++) {
    if (props.item.data[i].tag === 'menu-placeholder') {
      break
    }
    mainMenus[i] = props.item.data[i]
  }
  treeData.value = mainMenus
}

function onRefresh () {
  console.log('onRefresh enter')
  const instance = getCurrentInstance()
  console.log('onRefresh instance=', instance)
  if (instance) {
    instance.proxy?.$forceUpdate?.()
    console.log('onRefresh forceUpdate')
  }
}

function getEditAttr () {
  const tag = (store.state.selectItemInDraggable as {[tag:string]:string}).tag
  for (let i = 0; i < refTools.value.length; i++) {
    const item = (refTools.value[i] as{[item:string]: object}).item
    if (tag === (item as {[tag:string]: string}).tag) {
      return (item as {[attrs:string]: object}).attrs
    }
  }
  return [] as object[]
}

onMounted(async () => {
  try {
    store.state.pageItems = {} as BaseTree
    store.state.selectItemInDraggable = {} as BaseTree
    structMenu()
    refTools.value = await apiFetchData(apiToolComponentPath)
  } catch (error) {
    console.error(error)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, {
      style: {"margin":"0px"},
      align: "middle"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: refTreeMenuSpan.value }, {
          default: _withCtx(() => [
            _createVNode(_component_el_text, {
              class: "mx-1",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("菜单树")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["span"]),
        _createVNode(_component_el_col, {
          span: refComponetToolSpan.value,
          align: "middle"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_text, {
              class: "mx-1",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("组件栏")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["span"]),
        _createVNode(_component_el_col, { span: refEditWindowSpan.value }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, {
              style: {"margin":"0px"},
              align: "middle"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox, {
                      modelValue: refIsPreview.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((refIsPreview).value = $event)),
                      label: "预览",
                      onChange: onPreview,
                      size: "large"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_el_text, { type: "info" }, {
                      default: _withCtx(() => [
                        _createTextVNode("  " + _toDisplayString(refSelectFullPath.value), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  align: "right"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (savePage()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("保存")
                      ]),
                      _: 1
                    }),
                    _createTextVNode("   "),
                    (refAtrrWindowSpan.value==0)
                      ? (_openBlock(), _createBlock(_component_el_checkbox, {
                          key: 0,
                          modelValue: refIsShow.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((refIsShow).value = $event)),
                          label: "显示",
                          onChange: recaculateSpan,
                          size: "large"
                        }, null, 8, ["modelValue"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["span"]),
        _createVNode(_component_el_col, { span: refAtrrWindowSpan.value }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, {
              style: {"margin":"0px"},
              align: "middle"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_text, { type: "primary" }, {
                      default: _withCtx(() => [
                        _createTextVNode("属性")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 12,
                  align: "right"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox, {
                      modelValue: refIsShow.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((refIsShow).value = $event)),
                      label: "隐藏",
                      onChange: recaculateSpan,
                      size: "large"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["span"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, {
      gutter: 12,
      class: "demo-radius"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: refTreeMenuSpan.value }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "radius",
              style: _normalizeStyle(`var(--el-border-radius-base)`)
            }, [
              _createVNode(_component_el_tree, {
                data: treeData.value,
                onNodeClick: onNodeClick
              }, null, 8, ["data"])
            ], 4)
          ]),
          _: 1
        }, 8, ["span"]),
        _createVNode(_component_el_col, { span: refComponetToolSpan.value }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "radius",
              style: _normalizeStyle(`var(--el-border-radius-base)`)
            }, [
              _createVNode(ComponentList, { itemList: refTools.value }, null, 8, ["itemList"])
            ], 4)
          ]),
          _: 1
        }, 8, ["span"]),
        _createVNode(_component_el_col, { span: refEditWindowSpan.value }, {
          default: _withCtx(() => [
            (!refIsPreview.value)
              ? (_openBlock(), _createBlock(PageEditor, {
                  key: 0,
                  tabName: __props.tabName,
                  item: _unref(store).state.pageItems
                }, null, 8, ["tabName", "item"]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  id: "edit-div",
                  class: "radius",
                  style: _normalizeStyle(`var(--el-border-radius-base)`)
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.pageItems.children, (subItem) => {
                    return (_openBlock(), _createBlock(ViewRender, {
                      tabName: __props.tabName,
                      item: subItem,
                      key: subItem.tag
                    }, null, 8, ["tabName", "item"]))
                  }), 128))
                ], 4))
          ]),
          _: 1
        }, 8, ["span"]),
        _createVNode(_component_el_col, { span: refAtrrWindowSpan.value }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "radius",
              style: _normalizeStyle(`var(--el-border-radius-base)`)
            }, [
              _createVNode(_component_el_row, { class: "attr-row" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { class: "attr-label" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_text, { type: "info" }, {
                        default: _withCtx(() => [
                          _createTextVNode("id:")
                        ]),
                        _: 1
                      }),
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _unref(store).state.selectItemInDraggable.id,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(store).state.selectItemInDraggable.id) = $event)),
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getEditAttr(), (subItem) => {
                return (_openBlock(), _createBlock(_component_el_row, {
                  key: subItem.id,
                  class: "attr-row"
                }, {
                  default: _withCtx(() => [
                    (_unref(stringEqual)(subItem.action,'refresh'))
                      ? (_openBlock(), _createBlock(_component_el_col, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: onRefresh
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(subItem.label), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createVNode(_component_el_col, { class: "attr-label" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_text, { type: "info" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(subItem.label) + ":", 1)
                                ]),
                                _: 2
                              }, 1024),
                              _hoisted_2
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, null, {
                            default: _withCtx(() => [
                              (subItem.tag=='TableItemEventEditor')
                                ? (_openBlock(), _createBlock(TableItemEventEditor, {
                                    key: 0,
                                    itemEvents: _unref(store).state.selectItemInDraggable[subItem.field],
                                    style: {}
                                  }, null, 8, ["itemEvents"]))
                                : (_openBlock(), _createBlock(_resolveDynamicComponent(subItem.tag), {
                                    key: 1,
                                    modelValue: _unref(store).state.selectItemInDraggable[subItem.field],
                                    "onUpdate:modelValue": ($event: any) => ((_unref(store).state.selectItemInDraggable[subItem.field]) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            ]),
                            _: 2
                          }, 1024)
                        ], 64))
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ], 4)
          ]),
          _: 1
        }, 8, ["span"])
      ]),
      _: 1
    })
  ], 64))
}
}

})